import React from 'react';

export const RiskometerHelpModal = () => (
  <p>
    The <strong>Riskometer</strong> displays two sets of instruments to help understand if the financial markets are
    currently sitting in a risk on or risk off mode. The prior day’s closing price is compared with the 60-day moving
    average to determine the amount of risk the instrument is showing.
  </p>
);
